import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import {
  Card,
  Button,
  Typography,
  TextField,
  InputAdornment,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import SearchIcon from "@material-ui/icons/Search";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";

import business from "../../../assets/images/businessicon.svg";
import agriculture from "../../../assets/images/agricultureicon.svg";
import home from "../../../assets/images/homeicon.svg";
import personal from "../../../assets/images/personalicon.svg";
import twoWheeler from "../../../assets/images/twoweelericon.svg";
import exportCredit from "../../../assets/images/exportcrediticon.svg";
import education from "../../../assets/images/educationalicon.svg";
import loanAgainstFD from "../../../assets/images/loanagainstfixeddeposit.svg";
import renewableEnergy from "../../../assets/images/renewableenargyloan.svg";
import loanAgainstGold from "../../../assets/images/loanagainstgold.svg";
import womenEntrepreneur from "../../../assets/images/womenentrepreneuricon.svg";
import penciledit from "../../../assets/images/penciledit.svg";
import { BaseUrl } from "../../../Environment";
import { getSecureItem } from "../../../utilsFunctions";
import Sidebar from "../../sidebar/sidebar";
import deleteicon from "../../../assets/images/deleteicon.svg";
import companylogo from "../../../assets/images/companylogo.svg";
import { Stack } from "@mui/material";
import { mergeSchemes } from "./staticSchemes";

const TOAST_OPTS = {
  position: "top-center",
  autoClose: 3000,
  hideProgressBar: true,
  closeOnClick: false,
  pauseOnHover: false,
  draggable: false,
};

// NOTE: JSS lets a rule reference a sibling class via `$className`, which is
// how ".schemeCard:hover .schemeTitle { color: white }" (a SCSS parent/child
// hover selector) gets reproduced here — `iconBox`, `applogo`, `schemeTitle`,
// `editIconWrapper` and `deleteIconWrapper` are all declared so `schemeCard`'s
// `&:hover` rule can target them by name.
const useStyles = makeStyles((theme) => ({
  schemecomponent: {
    margin: "10px 40px 0px 110px",
  },
  headerLogo: {
    height: 45,
  },
  searchInput: {
    width: 430,
    "& .MuiInputBase-root": {
      background: "#EFF2FF",
      borderRadius: 10,
      height: 40,
      padding: "0 15px",
    },
  },
  addScheme: {
    background: "#18d96c !important",
    color: "#fff !important",
    height: 40,
    width: 170,
    borderRadius: "8px !important",
    textTransform: "none !important",
    fontWeight: "600 !important",
  },
  schemeGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
    gap: 100,
  },

  // ---- card + all its hover-dependent children ----
  editIconWrapper: {
    position: "absolute",
    right: 15,
    top: 15,
    opacity: 0,
    transition: "0.3s",
  },
  deleteIconWrapper: {
    position: "absolute",
    right: 15,
    top: 45,
    opacity: 0,
    transition: "0.3s",
  },
  editIcon: {
    width: 18,
    transition: "0.3s",
  },
  deleteIcon: {
    width: 18,
    transition: "0.3s",
  },
  iconBox: {
    width: 45,
    height: 45,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: 18,
    transition: "0.3s",
  },

  schemeTitle: {
    textAlign: "center",
    color: "#36446c",
    fontSize: 18,
    fontWeight: 600,
    padding: "0 15px",
    transition: "0.3s",
  },
  schemeCard: {
    height: 140,
    borderRadius: "6px !important",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    position: "relative",
    transition: "0.3s",

    "&:hover": {
      boxShadow: "0 10px 25px rgba(0,0,0,0.12) !important",
      background: "linear-gradient(135deg, #00d95e, #4277db)",

      "& $editIconWrapper": { opacity: 1 },
      "& $deleteIconWrapper": { opacity: 1 },
      "& $schemeTitle": { color: "#fff" },
      "& $iconBox": { borderColor: "rgba(255,255,255,0.7)" },
      "& $editIcon": { filter: "brightness(0) invert(1)" },
      "& $deleteIcon": { filter: "brightness(0) invert(1)" },
    },
  },
}));

const authHeaders = () => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${getSecureItem("token")}`,
});

const Scheme = () => {
  const classes = useStyles();
  const history = useHistory();

  const [allScheme, setAllScheme] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [schemeToDelete, setSchemeToDelete] = useState(null);

  const GetAllSchemes = async () => {
    try {
      const loggedinUser = getSecureItem("loggedinUser");

      const resp = await axios.get(
        `${BaseUrl}/scheme/getAllSchemes?companyId=${loggedinUser?.companyId}`,
        { headers: authHeaders() },
      );

      // Order matters here — this is the sequence icons get assigned in
      const iconList = [
        business,
        agriculture,
        home,
        personal,
        twoWheeler,
        exportCredit,
        education,
        loanAgainstFD,
        renewableEnergy,
        loanAgainstGold,
        womenEntrepreneur,
      ];

      const schemes = mergeSchemes(resp.data?.data || []).map(
        (item, index) => ({
          ...item,
          image: iconList[index % iconList.length],
        }),
      );

      setAllScheme(schemes);
    } catch (err) {
      console.error("GetAllSchemes Error:", err);
      setAllScheme(mergeSchemes([]));
    }
  };

  useEffect(() => {
    GetAllSchemes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const addSchemeType = () => {
    history.push("/addeditscheme");
  };

  const editScheme = (schemeId) => {
    history.push(`/addeditscheme/${schemeId}`);
  };

  const openStaticScheme = (scheme) => {
    history.push({
      pathname: "/addeditscheme",
      search: `?preset=${encodeURIComponent(scheme.schemeType)}`,
      state: { presetSchemeType: scheme.schemeType },
    });
  };

  const handleEditClick = (scheme) =>
    scheme.schemeId ? editScheme(scheme.schemeId) : openStaticScheme(scheme);

  const openDeleteConfirm = (schemeId) => {
    setSchemeToDelete(schemeId);
    setDeleteDialogOpen(true);
  };

  const closeDeleteConfirm = () => {
    setSchemeToDelete(null);
    setDeleteDialogOpen(false);
  };

  const confirmDeleteScheme = async () => {
    if (!schemeToDelete) return;

    try {
      await axios.delete(`${BaseUrl}/scheme/deleteScheme/${schemeToDelete}`, {
        headers: authHeaders(),
      });

      toast.success("Savings type deleted successfully", TOAST_OPTS);
      await GetAllSchemes();
    } catch (err) {
      console.error("DeleteScheme Error:", err);
      toast.error("Failed to delete savings type", TOAST_OPTS);
    } finally {
      closeDeleteConfirm();
    }
  };

  const filteredSchemes = allScheme.filter((type) =>
    type.schemeType.toLowerCase().includes(searchText.toLowerCase()),
  );

  toast.configure({});

  return (
    <div>
      <Sidebar />
      <div className={classes.schemecomponent}>
        <Stack
          flexDirection={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
          marginBottom={3}
        >
          <img src={companylogo} className={classes.headerLogo} alt="logo" />
          <TextField
            className={`${classes.searchInput} Fonts`}
            placeholder="Search..."
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            InputProps={{
              disableUnderline: true,
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon style={{ color: "#aaa" }} />
                </InputAdornment>
              ),
            }}
          />
        </Stack>
        <div align="right" style={{ marginBottom: 25 }}>
          <Button
            className={`${classes.addScheme} Fonts`}
            onClick={addSchemeType}
          >
            + Add Savings Type
          </Button>
        </div>

        <div className={classes.schemeGrid}>
          {filteredSchemes.map((type) => (
            <Card
              className={classes.schemeCard}
              key={type.schemeId ?? `static-${type.schemeType}`}
            >
              <div className={classes.editIconWrapper}>
                <img
                  src={penciledit}
                  alt=""
                  className={classes.editIcon}
                  onClick={() => handleEditClick(type)}
                />
              </div>

              {type.schemeId && (
                <div className={classes.deleteIconWrapper}>
                  <img
                    src={deleteicon}
                    alt=""
                    className={classes.deleteIcon}
                    onClick={() => openDeleteConfirm(type.schemeId)}
                  />
                </div>
              )}

              <div className={classes.iconBox}>
                <img
                  src={type.image}
                  style={{ width: 40, height: 40 }}
                  className={classes.applogo}
                  alt=""
                />
              </div>

              <Typography className={`${classes.schemeTitle} Fonts`}>
                {type.schemeType}
              </Typography>
            </Card>
          ))}
        </div>
      </div>

      {/* Delete Modal Confirmation */}
      <Dialog open={deleteDialogOpen} onClose={closeDeleteConfirm}>
        <DialogTitle className="Fonts">Delete Savings Type</DialogTitle>
        <DialogContent>
          <Typography className="Fonts">
            Are you sure you want to delete this savings type? This action cannot be
            undone.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeDeleteConfirm} className="Fonts">
            Cancel
          </Button>
          <Button
            onClick={confirmDeleteScheme}
            className="Fonts"
            style={{ background: "#00D95E", color: "#fff" }}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default Scheme;
